import { CohortDTOTypeEnum } from '@atlassiansox/phobos-client-ts';

export enum CohortType {
  Rollup = 'rollup',
  Base = 'base',
  Reset = 'reset',
}

// TODO: any possible way to get this order from phobos-client-ts?
export const cohortTypeSorted = [
  CohortDTOTypeEnum.Global,
  CohortDTOTypeEnum.Geo,
  CohortDTOTypeEnum.Region,
  CohortDTOTypeEnum.Shard,
  CohortDTOTypeEnum.Db,
];

export type sloGroupSearchObjectType = {
  pageBase?: string;
  cohortType?: CohortType;
  hasBreachStatusOnly?: string;
  hideDrafts?: string;
  isDraft?: string;
  geos?: string;
  regions?: string;
  shards?: string;
  customFilters?: string;
};
